




























































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseModal from "@/resources/components/BaseModal.vue";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";
import MultiSelect from "@/resources/components/MultiSelect.vue";
import User from "@/app/models/User";

@Component({
    components: {
        MultiSelect,
        "base-modal"     : BaseModal,
        "loading-overlay": LoadingOverlay,
    },
})
export default class CreateOrEdit extends Vue {
    originalUser: string = '';
    user: User = new User({
        name    : '',
        email   : '',
        password: '',
    });

    mounted() {
        if (this.$route.params.user != null) {
            this.task(async () => {
                const data = await User.show(parseInt(this.$route.params.user));

                if (data instanceof User) {
                    this.user = data;
                    this.originalUser = data.name!;
                }
            });
        }
    }

    submit() {
        this.task(async () => await this.user.save())
            .then(() => this.close());
    }

    destroy() {
        if (confirm(this.$t('Weet u zeker dat u deze beheerder wilt verwijderen?') as string)) {
            this.task(async () => await this.user.destroy())
                .then(() => this.close());
        }
    }

    close() {
        // @ts-ignore
        this.$parent.reset();
        this.$router.push(this.$route.matched.slice(-2)[0])
    }
}
